<template lang="pug">
.log-wrapper
  .logbox
    b-card.shadow-lg.rounded.theme-glass
      div.p-4
        div.d-flex.flex-row.align-items-baseline
          h4 {{ $t("ui.combine.security_authentication") }}
        b-form.form-signin(@submit.stop.prevent="submit" novalidate :disabled="!submission.success")
          b-input-group
            b-input-group-text(slot="prepend")
              i.fas.fa-tag
            DebounceInput(
              required
              type="text"
              v-model.trim.lazy="$v.security_tag.$model"
              :placeholder='$t("ui.security_tag")'
              :maxLength="$v.security_tag.$params.maxLength.max"
              :dirty="$v.security_tag.$dirty"
              :error="$v.security_tag.$error"
              readonly
              )
          ValidateResult(:value="$v.security_tag" :name="$t('ui.security_tag')")
          b-input-group
            b-input-group-text(slot="prepend")
              i.fas.fa-lock
            DebounceInput(
              required
              ref="security_code"
              autofocus
              type="password"
              v-model.trim.lazy="$v.security_code.$model"
              :placeholder='$t("ui.security_code")'
              :disabled="loading"
              :maxLength="$v.security_code.$params.maxLength.max"
              :dirty="$v.security_code.$dirty"
              :error="$v.security_code.$error"
              )
          ValidateResult(:value="$v.security_code" :name="$t('ui.security_code')")
          div.row.pt-2
            div.col
              b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
          div.row
            .m-auto.w-70
              SubmitButton.btn-block.noboxshadow.br-8(icon="fa fa-sign-in-alt" :text="$t('ui.submit')" variant="warning" size="xs" :loading="loading" isModal=false)
</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, alphaNum } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data: function() {
    return {
      security_tag: "",
      security_code: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    security_tag: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    security_code: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    }
  },
  computed: {
    app() {
      return {
        title: config.appTitle,
        version: config.appVersion
      };
    },
    getSecurityTag() {
      return this.$store.getters.accountProfile[0].security_tag;
    },
    getProfileId() {
      return this.$store.getters.accountProfile[0].profile_id;
    }
  },
  mounted: function() {
    const url = this.$route.query.redirect;
    if (url) {
      this.redirect = url;
    }
    this.security_tag = this.getSecurityTag;
    this.$refs.security_code.$el.focus();
  },
  methods: {
    reset: function() {
      this.$v.$reset();
      this.submission.success = true;
      this.submission.status = "";
      this.$refs.security_code.$el.focus();
    },
    submit: function() {
      this.reset();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let profile_id = this.getProfileId;
        let security_code = this.security_code;
        this.loading = true;
        this.$store
          .dispatch("user/security", { profile_id, security_code })
          .then(response => {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.status;
            if (this.submission.success == true) {
              if (this.$store.getters.accountProfile[0].status == "RESET") {
                this.$router.push("/resetPassword")
              } else {
                this.$router.push(response.redirect)
              }
            }
          })
          .catch(response => {
            this.loading = false;
            this.submission.success = response.success;
            // this.submission.status =  response.status;
            this.submission.status = this.$t("error." + response.status);
          });
      }
    }
  }
};
</script>

